import { useCallback } from 'react';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { SgIcon } from '@/components/sg-design-system/components/display/SgIcon';
import { SgButton } from '@/components/sg-design-system/components/input/SgButton';
import { useUserContext } from '@/context/UserContext.tsx';
import { useAppDispatch } from '@/store/hooks.ts';
import { toggleWorkspaceCanTrade } from '@/store/workspace/slice.ts';

// Displayed only when the workspace itself is locked: when the user has no trading clearance at all,
// unlocking the workspace would not grant any execution right, so the banner would be misleading.
export function WorkspaceLockedBanner() {
  const dispatch = useAppDispatch();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { tradePermission } = useUserContext();

  const handleUnlockClick = useCallback(() => {
    sgwtWebAnalytics?.trackEvent('Workspace', 'Unlock workspace');
    dispatch(toggleWorkspaceCanTrade());
  }, [dispatch, sgwtWebAnalytics]);

  if (tradePermission !== 'disallowedByWorkspace') {
    return null;
  }

  return (
    <div
      role="alert"
      data-e2e="workspace-locked-banner"
      className="alert alert-discreet-warning d-flex align-items-center justify-content-between gap-3 rounded-0 border-0 mb-0 px-3 py-2"
    >
      <span className="d-flex align-items-center gap-2">
        <SgIcon icon="lock" size="md" className="text-warning" />
        <FormattedMessage id="workspace.locked.banner.message" />
      </span>
      <SgButton
        purpose="outline"
        color="warning"
        size="md"
        data-e2e="workspace-banner-unlock-btn"
        onClick={handleUnlockClick}
      >
        <FormattedMessage id="workspace.locked.banner.unlock" />
      </SgButton>
    </div>
  );
}
